import { createAiPromptRequest } from '../../../../ai-insights/aiInsightsTypes';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import { getLowestScoringMetrics } from './batch';
import { wellnessInsightPrompt } from './prompt';
import type { WellnessInsightInput, WellnessInsightRunnerOutput } from './types';

export const buildWellnessInsightRequest = (response: WellnessInsightInput): WellnessInsightRunnerOutput | null => {
  const selectedMetrics = getLowestScoringMetrics(response);
  if (selectedMetrics.length === 0) return null;

  const profile = transactionActionExecutionProfiles.wellness_insights;

  return {
    transport: 'structured_model',
    selectedMetrics,
    request: createAiPromptRequest({
      userPrompt: { text: wellnessInsightPrompt.prompt },
      agent: 'ai-insights-v2',
      context: {
        text: wellnessInsightPrompt.contextPrefix,
        data: {
          metrics: selectedMetrics,
          wellnessScore: response,
        },
      },
      outputSchema: wellnessInsightPrompt.schema.schema,
      options: {
        model: profile.model,
        temperature: profile.temperature,
        maxOutputTokens: profile.maxOutputTokens,
      },
    }),
  };
};
